import React from "react";

const ChairmanMessageContainer = () => {
  return (
    <>
      <div className="flex flex-col gap-5 w-[694px] px-2">
        <div className="flex flex-col gap-4">
          <h1 className="text-[28px] font-semibold border-b-[1px] border-gray-400">
            Chairman's Message
          </h1>
          <p className="text-[15px] font-medium">
            {" "}
            CSSE was intended to be a medium of making education easy for
            students who are unable to attend regular classes. The challenge
            before us was to make the instructional. delivery of curriculum
            convenient and as effective as regular classes for the students. It
            had to be a well-planned and organized extended learning endeavor
            which allowed students to pursue other activities without affecting
            their learning. Reaching out to them through the online medium was
            an excellent way to deliver educational resources and nullify the
            location constraint. The National policy on Education suggested
            strengthening of CSSE for extending open learning facilities in a
            phased manner at secondary and Sr. Secondary levels all over the
            country and abroad as an independent system with its own curriculum
            and examination leading to awarding of certificates. This was
            intended to address the needs of students on working professionals
            in India and abroad to further the cause of spreading education.
            CSSE offers a viable and convenient approach for education as
            comprehensive study material is delivered online after admission.
            The process of admission is simple too as students only need to
            register online and get admitted with the enrollment number sent
            right away. The instructional resources made available to the
            students are without the bottleneck of language. They have the
            option to choose the language of their study material. The results
            of pass students are backed by online verification. Spreading the
            cause of making education convenient through the internet was a
            novel initiative suggested by the National Policy on Education and
            we took this opportunity to start CSSE. The way our instructional
            deliver and online facilitation of educational courses have expanded
            in India and abroad, it is a fulfillment of our aspiration to play a
            pivotal role on making education convenient for students all over
            the world. You can choose subjects from the scheme of studies given
            in table. However, you will be required to successfully complete a
            minimum of five subjects with at least one language or at most two
            languages, which is compulsory for certification.
            <div className="text-end font-semibold">
              Sd/- <br /> Chairman Council for Secondary and Senior Secondary
              Education <br /> Delhi.
            </div>
          </p>
        </div>
      </div>
    </>
  );
};

export default ChairmanMessageContainer;
